const rexgexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

const regexPhone = /^(?:[+\d].*\d|\d)$/;

const regexPassword = /^\S*$/;

export { rexgexEmail, regexPhone, regexPassword };
